import { NUMBERS } from "../lib/dartEngine";
import { Undo2 } from "lucide-react";

export default function DartPad({ onDart, onUndo }) {
  return (
    <>
      {/* Number pad — grouped Single / Double / Treble cards (no mode switching) */}
      <div className="grid grid-cols-4 sm:grid-cols-5 gap-2">
        {NUMBERS.map((n) => (
          <div
            key={n}
            className="flex flex-col rounded-md overflow-hidden border border-[#262626] bg-[#141414]"
          >
            <button
              data-testid={`dart-${n}`}
              onClick={() => onDart(n, 1)}
              className="py-3.5 font-display text-2xl font-bold text-white hover:bg-[#1f1f1f] active:bg-[#007AFF] transition-colors duration-100"
            >
              {n}
            </button>
            <div className="grid grid-cols-2 border-t border-[#262626]">
              <button
                data-testid={`dart-d-${n}`}
                onClick={() => onDart(n, 2)}
                className="py-4 font-display text-lg font-bold text-[#4C9AFF] border-r border-[#262626] hover:bg-[#1f1f1f] active:bg-[#007AFF] active:text-white transition-colors duration-100"
              >
                D{n}
              </button>
              <button
                data-testid={`dart-t-${n}`}
                onClick={() => onDart(n, 3)}
                className="py-4 font-display text-lg font-bold text-[#4C9AFF] hover:bg-[#1f1f1f] active:bg-[#007AFF] active:text-white transition-colors duration-100"
              >
                T{n}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Special inputs + actions */}
      <div className="grid grid-cols-4 gap-2 mt-2">
        <button
          data-testid="dart-25"
          onClick={() => onDart(25, 1)}
          className="panel rounded-md py-4 font-display text-lg font-bold text-[#4ADE80] hover:bg-[#1f1f1f] transition-colors duration-100"
        >
          25
        </button>
        <button
          data-testid="dart-50"
          onClick={() => onDart(25, 2)}
          className="panel rounded-md py-4 font-display text-lg font-bold text-[#F87171] hover:bg-[#1f1f1f] transition-colors duration-100"
        >
          BULL 50
        </button>
        <button
          data-testid="dart-miss"
          onClick={() => onDart(0)}
          className="panel rounded-md py-4 font-display text-lg font-bold text-slate-400 hover:bg-[#1f1f1f] transition-colors duration-100"
        >
          MISS / 0
        </button>
        <button
          data-testid="undo-dart-btn"
          onClick={onUndo}
          className="panel rounded-md py-4 font-display text-sm font-bold uppercase tracking-wide text-slate-300 hover:text-[#F87171] flex items-center justify-center gap-1.5 transition-colors duration-100"
        >
          <Undo2 className="w-4 h-4" /> Undo
        </button>
      </div>
    </>
  );
}
